import { washLanguageData } from '@/utils/wash.js'
import { getNodeByFlag } from '../../common/controlBar/controlBarDialog/metaComponent/utils'
import { createMuiltLanguagesJson } from "@/components/widgets/nav/repeatNumber.js";
import { deepCopy } from '@/mm/utils.js'
const washDataArabic = (node, flag, dataType, englishTitleLeft, englishTitleRight) => {
  const objLeft = getNodeByFlag(node, flag).data[dataType][englishTitleLeft]
  if (!objLeft || typeof objLeft.diannao === 'object') return
  const objRight = getNodeByFlag(node, flag).data[dataType][englishTitleRight]
  const objLeftValue = deepCopy(objLeft)
  const objRightValue = deepCopy(objRight)
  for (let key in objLeft) {
    objLeft[key] = createMuiltLanguagesJson(objLeftValue[key], { 'rtl': objRightValue[key] });
    objRight[key] = createMuiltLanguagesJson(objRightValue[key], { 'rtl': objLeftValue[key] });
  }
}
const washDataArabicAlign = (node, flag, dataType, englishTitle, defaultValue, rtlValue) => {
  const obj = getNodeByFlag(node, flag).data[dataType][englishTitle]
  if (!obj || typeof obj.diannao === 'object') return
  const objValue = deepCopy(obj)
  for (let key in obj) {
    if (objValue[key] === defaultValue) {
      obj[key] = createMuiltLanguagesJson(objValue[key], { 'rtl': rtlValue });
    } else if (objValue[key] === rtlValue) {
      obj[key] = createMuiltLanguagesJson(objValue[key], { 'rtl': defaultValue });
    }
  }
}
const washData = (node) => {
  try {
    switch (node._type) {
      case 'home_product_five':
        washLanguageData(node, 'VIEW MORE', 'name')
        getNodeByFlag(node, 'home-product-slide').list[1].list[0].list[2].flag = 'main_button'
        let ArabicRule = [
          {
            flag: 'home-product-title',
            dataType: 'design',
            englishTitleLeft: 'self_marginLeft',
            englishTitleRight: 'self_marginRight',
          },
          {
            flag: 'home-product-thumbs-img',
            dataType: 'design',
            englishTitleLeft: 'self_marginLeft',
            englishTitleRight: 'self_marginRight',
          },
          {
            flag: 'home-product-intro',
            dataType: 'design',
            englishTitleLeft: 'self_marginLeft',
            englishTitleRight: 'self_marginRight',
          },
          {
            flag: 'home-product-intro',
            dataType: 'design',
            englishTitleLeft: 'self_paddingLeft',
            englishTitleRight: 'self_paddingLeft',
          },
          {
            flag: 'main_button',
            dataType: 'design',
            englishTitleLeft: 'self_marginLeft',
            englishTitleRight: 'self_marginRight',
          },
          {
            flag: 'main_button',
            dataType: 'design',
            englishTitleLeft: 'self_paddingLeft',
            englishTitleRight: 'self_paddingRight',
          },
          {
            flag: 'home-product-title',
            dataType: 'design',
            onlyEnglish: 'title_textAlign',
            englishTitleLeft: 'left',
            englishTitleRight: 'right',
          },
          {
            flag: 'home-product-title',
            dataType: 'hover',
            onlyEnglish: 'title_hoverTextAlign',
            englishTitleLeft: 'left',
            englishTitleRight: 'right',
          }
        ]
        ArabicRule.forEach(item => {
          if (item.onlyEnglish) {
            washDataArabicAlign(node, item.flag, item.dataType, item.onlyEnglish, item.englishTitleLeft, item.englishTitleRight)
          } else {
            washDataArabic(node, item.flag, item.dataType, item.englishTitleLeft, item.englishTitleRight)
          }
        })
        // washDataArabic(node, 'home-product-title', 'design', 'self_marginLeft', 'self_marginRight')
        // washDataArabicAlign(node, 'home-product-title', 'design', 'title_textAlign', 'left', 'right')
        // washDataArabicAlign(node, 'home-product-title', 'hover', 'title_hoverTextAlign', 'left', 'right')
        // washDataArabic(node, 'home-product-thumbs-img', 'design', 'self_marginLeft', 'self_marginRight')
        // washDataArabic(node, 'home-product-intro', 'design', 'self_marginLeft', 'self_marginRight')
        // washDataArabic(node, 'home-product-intro', 'design', 'self_paddingLeft', 'self_paddingRight')
        // washDataArabic(node, 'main_button', 'design', 'self_marginLeft', 'self_marginRight')
        // washDataArabic(node, 'main_button', 'design', 'self_paddingLeft', 'self_paddingRight')

        break
    }
  } catch (err) {
    console.log('err--', err)
  }
}
export { washData }
